import React from 'react'
import { useLocation } from 'react-router-dom'

function LogsNavigator() {
    const { pathname } = useLocation()
    return (
        <div className='flex flex-wrap gap-2 justify-center items-center my-5'>
            <a className={`px-4 py-2 text-lg font-medium rounded-2xl ${pathname === "/session-history" ? "bg-primary-200 text-white" : "text-primary-200 bg-blue-100"}`} href="/session-history">Session History</a>
            <a className={`px-4 py-2 text-lg font-medium rounded-2xl ${pathname === "/session-logs" ? "bg-primary-200 text-white" : "text-primary-200 bg-blue-100"}`} href="/session-logs">User History</a>
        </div>
    )
}
export default LogsNavigator